/**
 * Conversion table for non-functional SOP Class UIDs
 *
 * Item: [From, To]
 *
 * Where:
 * - From: Incompatible SOP Class UID
 * - To: Compatible alternative
 */
const CONVERSION_TABLE = new Map([
  // Phillips velho que não reconhecia subdivisão de tipos de imagem de US
  // Assumir subdivisão ".1" (Ultrasound Image Storage)
  ['1.2.840.10008.5.1.4.1.1.6', '1.2.840.10008.5.1.4.1.1.6.1'],
]);

/**
 *
 * Refer to {@link sanitizeSopClass} for details
 *
 * @param sopClass SOP Class UID
 * @returns An OHIFViewers-compatible alternative SOP Class UID
 */
function sanitize(sopClass: string): string {
  return CONVERSION_TABLE.get(sopClass) || sopClass;
}

/**
 *
 * Replaces non-functional SOP Class UIDs with OHIFViewers-compatible alternatives
 *
 * Mainly for cases wherein old machines don't recognize recent splits
 *
 * IE: "1.2.840.10008.5.1.4.1.1.6" getting split into:
 * - 1.2.840.10008.5.1.4.1.1.6.1 (Ultrasound Image Storage) <= Selected Default
 * - 1.2.840.10008.5.1.4.1.1.6.2 (Enhanced US Volume Storage)
 * - 1.2.840.10008.5.1.4.1.1.6.3 (Photoacoustic Image Storage)
 *
 * Refer to {@link CONVERSION_TABLE}
 *
 * @param instance Study metadata instance
 */
export default function sanitizeSopClass(instance) {
  instance.SOPClassUID = sanitize(instance.SOPClassUID);
}
